import UserEvent from "./UserEvent"
import { Emitter } from "../util/emitter"

export interface UserEventMap {
  event: UserEvent
}

export class UserEventEmitter extends Emitter<UserEventMap> {}
